<template>
  <section v-if="state.wholePartnersSectionShown" id="partneri" class="md:w-[70%] m-auto">
<!--    <div class="grid-cols-9 gap-12 mt-12 md:mt-24 md:grid">-->
<!--      <div class="flex col-span-3 md:justify-end">-->
<!--        <p class="font-semibold uppercase text-tiny">Partneři</p>-->
<!--      </div>-->
<!--      <div class="col-span-6">-->
<!--        <p class="text-big-body"><span class="mr-1 font-semibold">-->
<!--            Sami bychom to nezvládli.-->
<!--          </span></p>-->
<!--        Podpory všech partnerů si upřímně vážíme, protože nám každoročně umožňují zorganizovat skvělou akci a i díky nim-->
<!--        je ShopCamp takový, jaký je. Chcete se k nám přidat? Staňte se partnerem a vzdělávejte s námi českou-->
<!--        e&#8209;commerce,&nbsp;<a href="#kontakt" class="text-brand-blue hover:opacity-80">napište nám</a>.-->
<!--      </div>-->
<!--    </div>-->

    <div v-if="state.generalPartnersShown" class="grid-cols-9 gap-12 mt-12 md:mt-24 md:grid">
      <div class="col-span-9">
        <h3 class="font-semibold font-mono text-big-body uppercase">PLATINUM PARTNER
        </h3>
        <div class="flex flex-col mt-4 md:flex-row">
          <partners-card
            class="shadow-md"
            v-for="(generalPartner, i) in state.generalPartners"
            :key="generalPartner._uid"
          >
            <a :href="generalPartner.href" target="_blank">
              <img width="150" loading="lazy" :src="generalPartner.src.filename" :alt="generalPartner.name">
            </a>
          </partners-card>
        </div>
      </div>
    </div>


    <div v-if="state.patronsShown" class="mt-10">
        <h3 class="font-semibold font-mono text-big-body uppercase">GOLD PARTNEŘI</h3>
        <main-partners :partners="state.patrons"></main-partners>
    </div>

    <div v-if="state.mainPartnersShown" class="mt-10">
      <h3 class="font-semibold font-mono text-big-body uppercase">SILVER PARTNEŘI</h3>
      <main-partners :partners="state.mainPartners"></main-partners>
    </div>


    <div v-if="state.partnersShown" class="mt-10">
      <h3 class="font-semibold font-mono text-big-body uppercase">BRONZE PARTNEŘI</h3>
      <partners :partners="state.partners"></partners>
    </div>

    <div v-if="state.supportPartnersShown" class="mt-10">
      <h3 class="font-semibold font-mono text-big-body uppercase">Za podpory</h3>
      <support-partners :partners="state.supportPartners"></support-partners>
    </div>

    <div v-if="state.mediaPartnersShown" class="mt-10">
      <h3 class="font-semibold font-mono text-big-body uppercase">Mediální partneři</h3>
      <medial-partners :partners="state.mediaPartners"></medial-partners>
    </div>
  </section>
</template>


<script setup>
import MainPartners from './GridTypes/MainPartners.vue';
import Partners from './GridTypes/Partners.vue';
import SupportPartners from './GridTypes/SupportPartners.vue';
import MedialPartners from './GridTypes/MedialPartners.vue';
import PartnersCard from './PartnersCard.vue';
import { usePartnersStore } from '../../stores/partners';

const state = usePartnersStore();
</script>
